import React from 'react';
import OrdersTable from 'components/Table/Orders';
import { ordersModelBillingSlider } from 'components/Table/Orders/models';
import { Column } from 'components/Layout/Grid';

const BilletSlider: React.FC = () => (
  <>
    <Column className="w-100 max-w-lg-100 flex-1 px-0">
      <OrdersTable
        trackingKey="Slider Boletos"
        tableSearchClassName=" "
        model={ordersModelBillingSlider}
        pageSize={5}
        showButton={false}
        showFilter
        showTypeDateFilter
      />
    </Column>
  </>
);

export default BilletSlider;
